import setBreakpoints from 'helpers/breakpoints'
import isClient from './isClient' 

const {phablet, tablet, tabletBefore, phabletBefore} = setBreakpoints()

export const isDesktop = () => {
  if (!isClient()) return

  return !!window.matchMedia(`screen and (min-width:${tablet})`).matches
}

export const isTablet = () => {
  if (!isClient()) return

  return !!window.matchMedia(
    `screen and (min-width:${phablet}) and (max-width: ${tablet})`
  ).matches
}

export const isMobile = () => {
  if (!isClient()) return
  return !!window.matchMedia(`screen and (max-width:${phabletBefore})`).matches
}


export const isMobileDevice = isMobile()

export const isNoDesktop = () => {
  if (!isClient()) return

  return !!window.matchMedia(`screen and (max-width:${tabletBefore})`).matches
}

export const isIOS = () => {
  return [
    'iPad Simulator',
    'iPhone Simulator',
    'iPod Simulator',
    'iPad',
    'iPhone',
    'iPod'
  ].includes(navigator.platform)
  // iPad on iOS 13 detection
  || (navigator.userAgent.includes("Mac") && "ontouchend" in document)
}
